module.exports = __webpack_public_path__ + "static/media/favicon-cb.11a3235c.png";